import { Box, IconButton } from "@material-ui/core";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import React, { useCallback } from "react";
import { CreativesViewModel } from "validation/components/CreativeMappings/creativeMappingsRules";
import AddIcon from "@material-ui/icons/Add";
import ClearIcon from "@material-ui/icons/Clear";
import { FormControl, TextField } from "components";

export const MappingSectionForm = () => {
    const { control, errors } = useFormContext<{ creatives: CreativesViewModel[] }>();
    const { fields, remove, insert } = useFieldArray<CreativesViewModel>({
        control,
        name: "creatives",
    });

    const handleInsertRow = useCallback(
        (index: number) => {
            insert(index, {
                width: "",
                height: "",
                target: "",
            });
        },
        [insert]
    );

    return (
        <Box display="flex" flexDirection="column" flex={1} pb={2}>
            {fields.map((creative, index) => {
                const isOrphan = fields.length === 1;

                return (
                    <Box key={index} display="flex" flexDirection="row" mt={1} mb={1}>
                        <FormControl>
                            <Controller
                                name={`creatives[${index}].width`}
                                control={control}
                                as={
                                    <TextField
                                        label="Width"
                                        type="number"
                                        error={!!errors.creatives?.[index]?.width?.message}
                                        helperText={errors.creatives?.[index]?.width?.message}
                                    />
                                }
                            />
                        </FormControl>
                        <FormControl>
                            <Controller
                                name={`creatives[${index}].height`}
                                control={control}
                                as={
                                    <TextField
                                        label="Height"
                                        type="number"
                                        error={!!errors.creatives?.[index]?.height?.message}
                                        helperText={errors.creatives?.[index]?.height?.message}
                                    />
                                }
                            />
                        </FormControl>
                        <FormControl>
                            <Controller
                                name={`creatives[${index}].target`}
                                control={control}
                                as={
                                    <TextField
                                        label="Target"
                                        error={!!errors.creatives?.[index]?.target?.message}
                                        helperText={errors.creatives?.[index]?.target?.message}
                                    />
                                }
                            />
                        </FormControl>

                        <Box display="flex" justifyContent="flex-end" alignItems="center">
                            <IconButton onClick={() => handleInsertRow(index + 1)}>
                                <AddIcon color="primary" />
                            </IconButton>
                            <IconButton onClick={() => remove(index)} disabled={isOrphan}>
                                <ClearIcon color={isOrphan ? "disabled" : "error"} />
                            </IconButton>
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
};
